export const DEFAULT_OPERATIONAL_SECURITY_FORM_CONFIG = Object.freeze({
  keepOpenOnSave: false,
  refreshAfterSave: false,
  reloadButton: Object.freeze({
    visible: false,
    cooldownMs: 0,
  }),
});

export const OPERATIONAL_SECURITY_FORM_CONFIG_BY_TEMPLATE = Object.freeze({
  "Guardias de cajeros automáticos": Object.freeze({
    keepOpenOnSave: true,
    refreshAfterSave: true,
    reloadButton: Object.freeze({
      visible: true,
      cooldownMs: 3000,
    }),
  }),
});

export const resolveOperationalSecurityFormConfig = (templateName) => {
  const templateConfig =
    OPERATIONAL_SECURITY_FORM_CONFIG_BY_TEMPLATE[templateName] || {};

  return {
    ...DEFAULT_OPERATIONAL_SECURITY_FORM_CONFIG,
    ...templateConfig,
    reloadButton: {
      ...DEFAULT_OPERATIONAL_SECURITY_FORM_CONFIG.reloadButton,
      ...(templateConfig.reloadButton || {}),
    },
  };
};
